import { deleteCookie, getCookie, hasCookie, setCookie } from "cookies-next";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

// import { UserType } from '@/types/data'

const AuthContext = createContext(undefined);
export function useAuthContext() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error("useAuthContext must be used within an AuthProvider");
    }
    return context;
}
const authSessionKey = "accruewise-user";
const authTokenKey = "accruewise-token";

export function AuthProvider({ children }) {
    const navigate = useNavigate();
    const getSession = () => {
        const fetchedCookie = getCookie(authSessionKey)?.toString();
        if (!fetchedCookie) return;
        else return JSON.parse(fetchedCookie);
    };
    const [user, setUser] = useState(getSession());
    const saveSession = (user) => {
        setCookie(authSessionKey, JSON.stringify(user));
        setUser(user);
    };
    const removeSession = () => {
        deleteCookie(authSessionKey);
        deleteCookie(authTokenKey);
        setUser(undefined);
        navigate("/auth/login");
    };

    const isAuthenticated = hasCookie(authSessionKey);

    return (
        <AuthContext.Provider
            value={{
                user,
                isAuthenticated,
                saveSession,
                removeSession,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}
